export default __webpack_public_path__ + "static/media/upcoming.363a94f8.svg";